document.addEventListener('DOMContentLoaded', () => {
  // IntersectionObserver を使ってスクロール時に要素が表示領域に入ったかを監視する
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 要素が表示されたら、visible用のクラスを付与（アニメーション発火）
        entry.target.classList.add('fade-up--visible');

        // 一度表示されたら監視を終了（何度も繰り返さないようにする）
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 要素の10%が表示領域に入ったときに発火
  });

  // .fade-up クラスの付いたすべての要素を初期状態に設定し、監視対象にする
  document.querySelectorAll('.fade-up, .cs-l-section').forEach(el => {
    el.classList.add('fade-up--pre'); // 初期状態（透明＋下にずらす）
    observer.observe(el); // 監視を開始
  });
});

function scrollToTarget(selector, duration = 600) {
  const header = document.querySelector('header.header');
  const headerOffset = header ? header.offsetHeight : 0;
  const target = document.querySelector(selector);
  if (!target) return;

  const startY = window.scrollY;
  const targetY = target.getBoundingClientRect().top + startY - headerOffset;
  const distance = targetY - startY;
  let startTime = null;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    window.scrollTo(0, startY + distance * easeInOutQuad(progress));
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
  }

  requestAnimationFrame(animation);
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (targetId === "#" || targetId === "") return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        scrollToTarget(targetId, 800);
      }
    });
  });
});
